import React, { useEffect, useState } from 'react';
import useVideoConfigS3 from '../HelperComponent/useVideoConfigS3';

const useAudioHandleS3 = (audio = null, upKey = null, delKey = null) => {
    const [s3, bucketName] = useVideoConfigS3([]);
    const [audioProgress, setProgress] = useState(0);
    const [audioUrl, setFileUrl] = useState('');
    const [audioKey, setFileKey] = useState('');

    const [uploadFile, setFile] = useState(null);
    const [deleteFileKey, setDeleteFile] = useState(null);

    useEffect(() => {
        setDeleteFile(delKey);
        setFile(audio);
        setProgress(0);
        setFileUrl('');
    }, [audio, delKey]);

    const handleDelete = (delFile) => {
        const params = {
            Bucket: bucketName,
            Key: delFile,
        };
        s3.deleteObject(params, (err, data) => {
            if (err) {
                console.error(err);
                return;
            }
            console.log(data);
        });
    };

    if (deleteFileKey) {
        handleDelete(deleteFileKey);
        setDeleteFile(null);
        setFileUrl(null);
    }

    const handleUpload = (audio) => {
        if (!audio) {
            console.error('No audio file provided');
            return;
        }

        const extension = audio.name.split('.').pop();
        const audioName = new Date().getTime() + '.' + extension;

        const params = {
            Bucket: bucketName,
            Key: upKey + '/' + audioName,
            Body: audio,
        };

        s3.upload(params, (err, data) => {
            if (err) {
                console.error(err);
                return;
            }
            setFileUrl(data.Location);
            setFileKey(data.Key);
        }).on('httpUploadProgress', (evt) => {
            const progressPercentage = parseInt((evt.loaded * 100) / evt.total);
            setProgress(progressPercentage);
        });
    };

    useEffect(() => {
        if (uploadFile) {
            handleUpload(uploadFile);
            setFile(null);
        }
    }, [uploadFile]);

    return [audioUrl, audioKey, audioProgress, setFile, setDeleteFile];
};

export default useAudioHandleS3;